module.exports = __webpack_public_path__ + "img/icon-white-25.ffbf331e.svg";